
import Vue from 'vue';

export default Vue.extend({
  props: {
    id: {
      type: String,
      required: false,
    },
    name: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  methods: {
    onClick(): void {
      this.$emit('click');
    },
  },
});
